import {checkboxClasses, formGroupClasses, ThemeOptions} from '@mui/material';

import {Tokens} from '../../../../types/generated/Tokens';

export const MuiCheckbox = ({checkbox, filterchip, font, formgroup}: Tokens): ThemeOptions['components'] => ({
  MuiCheckbox: {
    defaultProps: {
      disableRipple: true,
      color: 'primary'
    },
    styleOverrides: {
      /* Styles applied to the root element. */
      root: {
        color: checkbox.primary.desktop.border.color,
        padding: 0,
        marginRight: 8,
        maxWidth: 24,
        maxHeight: 24,
        minWidth: 24,
        '&:hover': {
          backgroundColor: 'transparent'
        },
        '&.Mui-focusVisible, &:focus-within, &:active': {
          outline: 'none'
        },
        '&:active': {
          color: checkbox.primary.desktop.active.border.color
        },

        '&.MuiCheckboxChip-root': {
          '&': {
            height: '1px',
            opacity: 0,
            position: 'absolute',
            width: '1px',
            /* Styles updated to use border and background tokens. */
            '& + .MuiFormControlLabel-label': {
              background: filterchip.selectable.desktop.background.color,
              border: `1px solid ${filterchip.selectable.desktop.border.color}`,
              borderRadius: '4px',
              color: checkbox.primary.desktop.selected.background.color,
              fontFamily: typeof font.family === 'string' ? font.family : font.family.sans,
              fontSize: '14.22px',
              fontWeight: 700,
              padding: '4px 10px',

              '&:hover': {
                backgroundColor: filterchip.selectable.desktop.hover.background.color,
                borderColor: filterchip.selectable.desktop.hover.border.color,
                color: filterchip.selectable.desktop.hover.font.color
              }
            }
          },

          [`&.${checkboxClasses.checked}`]: {
            borderRadius: 0,
            left: '5px',
            opacity: 1,

            '& .MuiSvgIcon-root': {
              color: filterchip.selectable.desktop.selected.icon.background.color, // #FFF'
              width: '20px'
            },

            '& + .MuiFormControlLabel-label': {
              background: filterchip.selectable.desktop.selected.background.color,
              borderColor: filterchip.selectable.desktop.selected.border.color,
              color: filterchip.selectable.desktop.selected.font.color,
              paddingLeft: '30px', // to accommodate custom selected icon

              '&:focus': {
                padding: '5px'
              },
              '&:hover': {
                backgroundColor: filterchip.selectable.desktop.hover.background.color,
                borderColor: filterchip.selectable.desktop.hover.border.color,
                color: filterchip.selectable.desktop.hover.font.color
              }
            }
          },

          '&.MuiCheckboxChip-small': {
            '& + .MuiFormControlLabel-label': {
              fontSize: '12.64px',
              padding: '3px 8px'
            },

            [`&.${checkboxClasses.checked}`]: {
              '& .MuiSvgIcon-root': {
                color: filterchip.selectable.desktop.selected.icon.background.color, // '#FFF'
                width: '15px'
              },

              '& + .MuiFormControlLabel-label': {
                paddingLeft: '28px' // to accommodate selected icon
              }
            }
          }
        },
        /* Pseudo-class applied to the root element if `indeterminate={true}`. */
        '&.MuiCheckbox-indeterminate': {
          color: checkbox.primary.desktop.selected.border.color
        }
      },
      /* Styles applied to the root element if `color="primary"`. */
      colorPrimary: {
        [`&.${checkboxClasses.checked}`]: {
          color: checkbox.primary.desktop.selected.border.color,
          '&:hover': {
            // Removes MUI default
            backgroundColor: 'transparent',
            color: checkbox.primary.desktop.selected.hover.border.color
          }
        },
        [`&.${checkboxClasses.disabled}`]: {
          color: checkbox.primary.desktop.disabled.border.color
        }
      },
      /* Styles applied to the root element if `color="secondary"`. */
      colorSecondary: {
        [`&.${checkboxClasses.checked}`]: {
          color: checkbox.primary.desktop.selected.border.color,
          '&:hover': {
            // Removes MUI default
            backgroundColor: 'transparent',
            color: checkbox.primary.desktop.selected.hover.border.color
          }
        },
        [`&.${checkboxClasses.disabled}`]: {
          color: checkbox.primary.desktop.disabled.border.color
        }
      },
      /* Pseudo-class applied to the root element if `indeterminate={true}`. */
      indeterminate: {
        color: checkbox.primary.desktop.selected.border.color
      }
    }
  },
  MuiFormGroup: {
    styleOverrides: {
      root: {
        marginBottom: 8,
        [`&.${formGroupClasses.error}`]: {
          borderColor: formgroup.container.error.border.color,
          borderWidth: formgroup.container.error.border.width,
          borderStyle: formgroup.container.error.border.style
        }
      },
      row: {
        '> .MuiFormControlLabel-root': {
          marginRight: 16,
          paddingRight: 4
        }
      }
    }
  }
});
